// extracted by mini-css-extract-plugin
export var alt = "FeaturedProperties-module--alt--f81cc";
export var container = "FeaturedProperties-module--container--bbc32";
export var desktopOnly = "FeaturedProperties-module--desktopOnly--950ef";
export var main = "FeaturedProperties-module--main--edbe8";
export var mobileOnly = "FeaturedProperties-module--mobileOnly--f01b7";
export var styledContainer = "FeaturedProperties-module--styledContainer--2a4ea";
export var styledSubtitle = "FeaturedProperties-module--styledSubtitle--16f9e";
export var textLeft = "FeaturedProperties-module--textLeft--cc655";
export var title = "FeaturedProperties-module--title--d34f8";
export var visuallyHidden = "FeaturedProperties-module--visuallyHidden--fde56";